module.exports = __webpack_public_path__ + "static/img/lunbo-2026-3-new1.95fc4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/lunbo-2026-3-new1.png
// module id = 0Vxw
// module chunks = 36